export default __webpack_public_path__ + "static/media/how its works Icon 1.bddc4609.svg";